/** Default app font — must match the @font-face name in index.css */
export const DEFAULT_FONT = "Happy Paragraphs Regular";

/** Old / invalid names that were stored as theme values or CSS vars */
const LEGACY_FONT_ALIASES: Record<string, string> = {
  "font-happy-paragraphs-regular": DEFAULT_FONT,
  "HappyParagraphs-Regular": DEFAULT_FONT,
  "happy-paragraphs-regular": DEFAULT_FONT,
};

/**
 * Strip surrounding quotes from a stored font value.
 */
export const stripFontQuotes = (font: string): string =>
  font.replace(/^["'](.+)["']$/, "$1").trim();

/**
 * Normalize a stored font value to a canonical family name
 * that matches Settings options and @font-face declarations.
 */
export const normalizeFontName = (font?: string | null): string => {
  if (!font) {
    return DEFAULT_FONT;
  }

  // Full stacks from older resets: keep the first family
  const firstFamily = stripFontQuotes(font.split(",")[0] ?? font);
  return LEGACY_FONT_ALIASES[firstFamily] ?? (firstFamily || DEFAULT_FONT);
};

/**
 * Format a font family for a CSS custom property value.
 * Multi-word names need quotes; single-word names do not.
 */
export const formatFontForCss = (font: string): string => {
  const name = normalizeFontName(font);
  return /[\s,]/.test(name) ? `"${name}"` : name;
};
